import React from 'react';
import Ramp from './Ramp';

const PUB_ID = '1024392';
const WEBSITE_ID = '73000';

const pwUnits = [
    {
      type: 'flex_leaderboard',
    },
    {
      type: 'in_content',
    },
    // {
    //   type: 'corner_ad_video'
    // },
    // {
    //   type: 'precontent_ad_video'
    // },
    // { selectorId: 'top', type: 'leaderboard_atf' },
    // { selectorId: 'siderec', type: 'med_rect_atf' },
    // { selectorId: 'sideflex', type: 'med_rect_btf' },
  ];




export const withRampWrapper = (WrappedClassComponent) => {
  const ComponentWithRamp = (props) => {

    return (
      <>
        <Ramp PUB_ID={PUB_ID} WEBSITE_ID={WEBSITE_ID} pwUnits={pwUnits} forcePath="" />
        <WrappedClassComponent {...props} />
      </>
    );
  };

  return ComponentWithRamp;
};